module.exports = __webpack_public_path__ + "static/media/enlarge2.d663d5d7.svg";